<template>
  <td :class="cellClass">
    {{ content }}
  </td>
</template>

<script>
export default {
  props: {
    identifier: {
      type: Number,
      default: 0
    },
    row: {
      type: Number,
      default: 0
    },
    editMode: {
      types: Boolean,
      default: false
    },
    heading: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    onChange: {
      type: Function,
      default: () => {}
    },
  },
  data() {
    return {}
  },
  computed: {
    cellClass() {
      return this.heading ? 'TableCell TableCell--heading' : 'TableCell'
    },
  },
}
</script>

<style scoped>
.TableCell {
  background: #FFF;
  border: 1px solid #bed1c7;
  font-size: 0.9em;
  min-width: 140px;
  padding: 10px 16px;
  position: relative;
}

.TableCell--heading {
  background: #3c4148;
  color: #FFF;
  font-size: 1em;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/TableCell/TableCell.vue